'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableScroll = disableScroll;
exports.enableScroll = enableScroll;

function preventDefault(event) {
  event.preventDefault();
}

function disableScroll() {
  document.body.addEventListener('touchmove', preventDefault, {
    passive: false
  });
  document.body.style.overflow = 'hidden';
}

function enableScroll() {
  document.body.removeEventListener('touchmove', preventDefault, {
    passive: false
  });
  document.body.style.overflow = 'inherit';
}